import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { GenderRepository } from '../../../domain/repository';
import fixtures from './fixtures.json';

@Injectable()
export default class GenderDummyRepository implements GenderRepository {
  findAll() {
    return Promise.resolve(fixtures);
  }
}
